export default {
    centreServiceApiUrl: 'https://ep-app-centreservice-api-dev-nzn-f4f8d8e3bwd0c0bn.a01.azurefd.net',
    clientId: 'c2df31c2-f62f-4f7a-8118-8679d927418e',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 5,
    sampleRate: 0
};
